import styled, { css } from 'styled-components';
import { StyledButton } from '../../../../../../globalStyled';

export const StyledSaveLabel = styled.span`
  text-decoration: ${({ isMobile }) => (isMobile ? 'underline' : 'none')};
`;
export const StyledSaveButton = styled(StyledButton)`
  width: auto;
  position: relative;
  font-size: 13px;
  padding: 0 16px;
  margin: 0;
  height: 32px;
  min-width: 88px;
  border-radius: 6px;
  box-shadow: none;
  box-sizing: border-box;
  && {
    ${({ theme }) =>
      theme.isDark
        ? css`
            background: transparent;
            color: ${theme.text};
            border: 1px solid ${theme.border};
            &:hover:not(:disabled) {
              background: ${theme.hover};
            }
            &:disabled {
              background: transparent;
              color: ${theme.textFaint};
              border-color: ${theme.border};
            }
          `
        : css`
            background: ${theme.button};
            color: ${theme.buttonText};
            border: 1px solid ${theme.button};
          `}
  }
  ${({ isLive }) => {
    if (isLive) {
      return css`
        padding: 0 22px 0 16px;
      `;
    }
  }}

  ${({ mobile, theme }) => {
    if (mobile) {
      return css`
        background: ${theme.isDark ? 'transparent' : theme.card};
        padding: 0 10px;
        color: ${theme.text};
        font-weight: bold;
        box-shadow: none;
        border: ${theme.isDark ? `1px solid ${theme.border}` : 0};
        font-size: 13px;
        max-width: 200px;
        min-width: 100px;
        width: auto;
        white-space: nowrap;
      `;
    }
  }}

  && {
    ${({ $needsSave, theme }) =>
      $needsSave &&
      css`
        background: ${theme.danger};
        color: #fff;
        border: 1px solid ${theme.danger};
        &:hover:not(:disabled) {
          background: ${theme.danger};
          color: #fff;
        }
        &:disabled {
          background: ${theme.danger};
          color: #fff;
          border-color: ${theme.danger};
          opacity: 0.65;
        }
      `}
  }
`;

export const StyledLiveLabel = styled.span`
  background-color: #ff0404;
  color: #fff;
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 0 6px 0 6px;
  padding: 3px 5px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.04em;
  ${({ isMobile }) =>
    isMobile &&
    css`
      position: relative;
      background-color: transparent;
      color: #ff0404;
      text-decoration: none;
      padding-left: 10px;
      border-radius: 0;
    `}
`;
